import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiDatePicker from "react-multi-date-picker";


function CreatedDate(props: any) {
    const { selectedFilters, handleChange} = props
    const [isFocused, setIsFocused] = useState(false);
    const isDateSelected = selectedFilters?.created_on_from || selectedFilters?.created_on_to;
    const shouldShowLabel = isDateSelected || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? "date-lable" : ""}`}>
            <label>Created On</label>
            <MultiDatePicker
                value={[selectedFilters?.created_on_from, selectedFilters?.created_on_to]}
                onChange={(e: any) => handleChange(e, 'created_on')}
                range
                onOpen={() => setIsFocused(true)}
                onClose={() => setIsFocused(false)}
                editable={false}
            />
        </div>
    );
}

function StartDate(props: any) {
    const { selectedFilters, handleChange, placeholder } = props
    const [isFocused, setIsFocused] = useState(false);
    const isDateSelected = selectedFilters?.start_date_from || selectedFilters?.start_date_to;
    const shouldShowLabel = isDateSelected || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? "date-lable" : ""}`}>
            <label>{placeholder || 'Policy Effectivity Date'}</label>
            <MultiDatePicker
                value={[selectedFilters?.start_date_from, selectedFilters?.start_date_to]}
                onChange={(e: any) => handleChange(e, 'start_date')}
                range
                onOpen={() => setIsFocused(true)}
                onClose={() => setIsFocused(false)}
                editable={false}
            />
        </div>
    );
}

function EndDate(props: any) {
    const { selectedFilters, handleChange, placeholder } = props
    const [isFocused, setIsFocused] = useState(false);
    const isDateSelected = selectedFilters?.end_date_from || selectedFilters?.end_date_to;
    const shouldShowLabel = isDateSelected || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? "date-lable" : ""}`}>
            <label>{placeholder || 'Policy Expiry Date'} </label>
            <MultiDatePicker
                value={[selectedFilters?.end_date_from, selectedFilters?.end_date_to]}
                onChange={(e: any) => handleChange(e, 'end_date')}
                range
                onOpen={() => setIsFocused(true)}
                onClose={() => setIsFocused(false)}
                editable={false}
            />
        </div>
    );
}

function PaymentDue(props: any) {
    const { selectedFilters, handleChange } = props

    const [isFocused, setIsFocused] = useState(false);

    const isDateSelected = selectedFilters?.due_date_from || selectedFilters?.due_date_to;
    const shouldShowLabel = isDateSelected || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? "date-lable" : ""}`}>
            <label>Select Date</label>
            <MultiDatePicker
                value={[selectedFilters?.due_date_from, selectedFilters?.due_date_to]}
                onChange={(e: any) => handleChange(e, 'due_date')}
                range
                onOpen={() => setIsFocused(true)}
                onClose={() => setIsFocused(false)}
                editable={false}
            />
        </div>
    );
}

function PaymentDueFinance(props: any) {
    const { selectedFilters, handleChange } = props

    const [isFocused, setIsFocused] = useState(false);

    const isDateSelected = selectedFilters?.due_from_date || selectedFilters?.due_to_date;
    const shouldShowLabel = isDateSelected || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? "date-lable" : ""}`}>
            <label>Select Date</label>
            <MultiDatePicker
                value={[selectedFilters?.due_from_date, selectedFilters?.due_to_date]}
                onChange={(e: any) => handleChange(e, 'due_date')}
                range
                onOpen={() => setIsFocused(true)}
                onClose={() => setIsFocused(false)}
                editable={false}
            />
        </div>
    );
}

function FollowUpDate(props: any) {
    const { selectedFilters, handleChange} = props
    const [isFocused, setIsFocused] = useState(false);
    const isDateSelected = selectedFilters?.followup_date_from || selectedFilters?.followup_date_to;
    const shouldShowLabel = isDateSelected || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? "date-lable" : ""}`}>
            <label>Follow-up Date</label>
            <MultiDatePicker
                value={[selectedFilters?.followup_date_from, selectedFilters?.followup_date_to]}
                onChange={(e: any) => handleChange(e, 'followup_date')}
                range
                onOpen={() => setIsFocused(true)}
                onClose={() => setIsFocused(false)}
                editable={false}
            />
        </div>
    );
}

type ReceivedDateProps = {
  placeholder?: string;
  selectedDate: Date | null;
  onDateChange: (date: Date | null) => void;
  disabled?:boolean
  maxDate?:Date | null;
};


function ReceivedDate({ placeholder = "Receive Date", selectedDate, onDateChange,disabled,maxDate }: ReceivedDateProps) {
    // const [value, onChange] = useState(new Date());
    // const [startDate, setStartDate] = useState<Date | null>(null);
    const [isFocused, setIsFocused] = useState(false);
    const shouldShowLabel = !!selectedDate || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? "date-lable" : ""}`}>
            <label>{placeholder} </label>
            <DatePicker
                selected={selectedDate}
                onChange={onDateChange}
                dateFormat="dd/MM/yyyy"
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                maxDate={maxDate || null}
                disabled={disabled ? disabled : false}
                onKeyDown={(e) => e.preventDefault()}
            />
        </div>
    );
}

function CreatedOnDate(props: any) {
    const {selectedFilters, handleChange} = props
    const [isFocused, setIsFocused] = useState(false);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const selectedDate = selectedFilters?.created_on || null;
    const shouldShowLabel = !!selectedDate || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? 'date-lable' : ''}`}>
            <label>Created On</label>
            <DatePicker
                value={selectedFilters?.created_on || null}
                onChange={(date) => handleChange(date, 'created_on')}
                showMonthDropdown
                showYearDropdown
                maxDate={yesterday}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onKeyDown={(e) => e.preventDefault()}
            />
        </div>
    );
}

// function PaymentDate() {
//     // const [value, onChange] = useState(new Date());
//     const [startDate, setStartDate] = useState<Date | null>(null);

//     return (
//         <div className="datepicker">
//             <DatePicker
//                 selected={startDate}
//                 onChange={(date) => setStartDate(date)}
//                 peekNextMonth
//                 showMonthDropdown
//                 showYearDropdown
//                 dropdownMode="select"
//                 placeholderText="Payment Date"
//             />
//         </div>
//     );
// }

// function PaymentDateFrom() {
//     // const [value, onChange] = useState(new Date());
//     const [startDate, setStartDate] = useState<Date | null>(null);

//     return (
//         <div className="datepicker">
//             <DatePicker
//                 selected={startDate}
//                 onChange={(date) => setStartDate(date)}
//                 peekNextMonth
//                 showMonthDropdown
//                 showYearDropdown
//                 dropdownMode="select"
//                 placeholderText="Payment Date From"
//             />
//         </div>
//     );
// }   



// function PaymentDateTo() {
//     // const [value, onChange] = useState(new Date());
//     const [startDate, setStartDate] = useState<Date | null>(null);

//     return (
//         <div className="datepicker">
//             <DatePicker
//                 selected={startDate}
//                 onChange={(date) => setStartDate(date)}
//                 peekNextMonth
//                 showMonthDropdown
//                 showYearDropdown
//                 dropdownMode="select"
//                 placeholderText="Payment Date To"
//             />
//         </div>
//     );
// }  

function ReconcilitionStartDate(props: any) {
    const {selectedFilters, handleChange, maxDate, placeholder} = props
    const [isFocused, setIsFocused] = useState(false);

    const selectedDate = selectedFilters?.start_date || null;
    const shouldShowLabel = !!selectedDate || isFocused;

    return (
         <div className={`datepicker ${shouldShowLabel ? 'date-lable' : ''}`}>
            <label>{placeholder}</label>
            <DatePicker
                value={selectedFilters?.start_date || null}
                onChange={(date) => handleChange(date, 'start_date')}
                showMonthDropdown
                showYearDropdown
                maxDate={maxDate || null}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onKeyDown={(e) => e.preventDefault()}
            />
        </div>
    );
}

function ReconcilitionEndDate(props: any) {
    const {selectedFilters, handleChange, minDate, placeholder} = props
    const [isFocused, setIsFocused] = useState(false);

    const selectedDate = selectedFilters?.end_date || null;
    const shouldShowLabel = !!selectedDate || isFocused;

    return (
         <div className={`datepicker ${shouldShowLabel ? 'date-lable' : ''}`}>
             <label>{placeholder} </label>
            <DatePicker
                value={selectedFilters?.end_date || null}
                onChange={(date) => handleChange(date, 'end_date')}
                showMonthDropdown
                showYearDropdown
                minDate={minDate || null}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onKeyDown={(e) => e.preventDefault()}
            />
        </div>
    );
}


function RemittanceDate(props: any) {
    const {selectedFilters, handleChange, maxDate, placeholder,name} = props
    const [isFocused, setIsFocused] = useState(false);

    const selectedDate = selectedFilters?.[name] || null;
    const shouldShowLabel = !!selectedDate || isFocused;
    return (
         <div className={`datepicker remitance ${shouldShowLabel ? 'date-lable' : ''}`}>
            {/* <label>{placeholder}</label> */}
            <DatePicker
                value={selectedDate}
                onChange={(date) => handleChange(date, name)}
                showMonthDropdown
                showYearDropdown
                maxDate={maxDate || null}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onKeyDown={(e) => e.preventDefault()}
            />
        </div>
    );
}





export { CreatedDate, StartDate, EndDate, PaymentDue, FollowUpDate,ReceivedDate, CreatedOnDate, PaymentDueFinance, ReconcilitionStartDate, ReconcilitionEndDate,RemittanceDate };
